import { Outlet, ShouldRevalidateFunction, useLoaderData, useLocation } from '@remix-run/react';
import { is_sms_link_path } from '~/lib/sms-link-scrub';
import { LoaderFunctionArgs } from '@remix-run/cloudflare';
import { remix_title_merge } from '~/lib/remix';
import Full from '~/components/layout/Full';
import { TenantBrandProvider } from '~/tenants/common/TenantContextProvider';
import RouteErrorBoundary from '~/components/RouteErrorBoundary';
import { useUserGuiding } from '~/components/hooks/useAuthenticatedUserGuiding';
import { remix_brand_resolved } from '~/.server/demo/brand-route';

export async function loader(args: LoaderFunctionArgs) {
  return {
    brand: await remix_brand_resolved(args),
  };
}

export const shouldRevalidate: ShouldRevalidateFunction = () => false;

export const meta = remix_title_merge<typeof loader>((data) => data.brand.name);

export function ErrorBoundary() {
  return <RouteErrorBoundary />;
}

export default function () {
  const { brand } = useLoaderData<typeof loader>();

  // Not on a text's sign-in link page: its URL is a credential (lib/sms-link-scrub.ts).
  useUserGuiding({ skip: is_sms_link_path(useLocation().pathname) });

  return (
    <TenantBrandProvider brand={brand}>
      <Full>
        <div className="flex max-sm:flex-col min-h-full">
          <div className="flex items-col items-end sm:items-center justify-center sm:px-8 lg:px-16 xl:px-32 max-sm:py-8 sm:flex-1">
            <img src={brand.logoVector ?? brand.logoRaster} className="max-w-64 max-sm:max-h-20" />
          </div>
          <div className="bg-white flex flex-col items-col items-center sm:justify-center p-8 lg:px-16 xl:px-32 flex-1">
            <div className="max-w-md w-full">
              <Outlet />
            </div>
          </div>
        </div>
      </Full>
    </TenantBrandProvider>
  );
}
